import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import TrackingConfig from '../../providerConfiguration/components/orderTracking';
import AmountControl from '../../providerConfiguration/components/orderLimits';
import AuthorizationList from './authorizationList';
import ProvidersImportations from './importations';
import ManagementDetail from './managementDetail';
import SequenceConfig from './sequenceConfig';
import AmountReport from './amountReport';
import SpecialOrders from './specials';
import Management from './management';
import ManualOrders from './manual';
import StockOrders from './stock';

export const providerOrdersRoutes = [
  {'component': <StockOrders/>, 'path': paths.ProviderStockOrders},
  {'component': <ManualOrders/>, 'path': paths.ProviderManualOrders},
  {'component': <AmountReport/>, 'path': paths.ProviderAmountReport},
  {'component': <SpecialOrders/>, 'path': paths.ProviderSpecialOrders},
  {'component': <Management/>, 'path': paths.ProviderOrdersManagement},
  {'component': <AmountControl/>, 'path': paths.ProviderOrdersAmountControl},
  {'component': <TrackingConfig/>, 'path': paths.ProviderOrdersTrackingConfig},
  {'component': <SequenceConfig/>, 'path': paths.ProviderOrdersSequenceConfig},
  {'component': <ProvidersImportations/>, 'path': paths.ProvidersImportations},
  {'component': <ManagementDetail />, 'path': paths.ProviderOrdersManagementDetail},
  {'component': <AuthorizationList />, 'path': paths.ProviderOrdersAuthorizationList},
];
